import { render, staticRenderFns } from "./ConsultarUnimed.vue?vue&type=template&id=1b17ca09&scoped=true"
import script from "./ConsultarUnimed.vue?vue&type=script&lang=js"
export * from "./ConsultarUnimed.vue?vue&type=script&lang=js"
import style0 from "./ConsultarUnimed.vue?vue&type=style&index=0&id=1b17ca09&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b17ca09",
  null
  
)

export default component.exports